module.exports = __webpack_public_path__ + "img/no-tx.a9b237fe.png";